exports.PRIORITY = {
    HIGH: 'high',// Send OTP Email Verification
    MEDIUM: 'transectional',// order place
    LOW: 'promotional',// offer coupons
}